import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../features';

const errorStyles = css`
  color: #e60012;
  font-size: 12px;
  margin: 4px 0;
`;

export const ChatWarnings: React.FC = () => {
  const { t } = useTranslation(['chat', 'translation']);
  const { warnTypes } = useSelector((state: RootState) => state.chat);
  return (
    <>
      {warnTypes.find(wt => wt === 'text-is-too-long') && (
        <p className={errorStyles}>{t('error_notice_too_long')}</p>
      )}
      {warnTypes.find(wt => wt === 'invalid-char') && (
        <p className={errorStyles}>{t('error_notice_invalid_char')}</p>
      )}
    </>
  );
};
